import { Suspense } from 'react';
import { CompanyLinks, PersonNotes, PersonPrivateInformation } from '@features';
import { Grid, Skeleton, Stack } from '@mantine/core';

const COL_SPAN = { base: 12, md: 6 };
const SKELETON_HEIGHT = 360;

export const PersonDetailsGeneralPage: React.FC = () => {
  return (
    <Stack py="md">
      <Grid>
        <Grid.Col span={COL_SPAN}>
          <Suspense fallback={<Skeleton height={SKELETON_HEIGHT} />}>
            <PersonPrivateInformation />
          </Suspense>
        </Grid.Col>
        <Grid.Col span={COL_SPAN}>
          <Suspense fallback={<Skeleton height={SKELETON_HEIGHT} />}>
            <PersonNotes />
          </Suspense>
        </Grid.Col>
      </Grid>
      <Suspense fallback={<Skeleton height={SKELETON_HEIGHT} />}>
        <CompanyLinks />
      </Suspense>
    </Stack>
  );
};
